import { render, staticRenderFns } from "./TypeDragDrop.vue?vue&type=template&id=bf6c9ab4"
import script from "./TypeDragDrop.vue?vue&type=script&lang=js"
export * from "./TypeDragDrop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports